import { Navigate } from "react-router";
import { useAppParams } from "@hooks/useAppParams";
import { PATIENT_SHARED_EDUCATIONAL_MATERIALS } from "@routes/routes";
import { EducationalMaterialsTabs } from "@Core/patientShared/PatientShared.types";

interface Props {
  tab: EducationalMaterialsTabs;
}

/** Redirects the legacy `/educationalMaterials/{text,pdf,video}` paths to `?tab=`. */
const PatientSharedEducationalMaterialsRedirect = ({ tab }: Props) => {
  const { patientId } = useAppParams();

  return (
    <Navigate
      to={`${PATIENT_SHARED_EDUCATIONAL_MATERIALS.replace(
        ":patientId",
        String(patientId),
      )}?tab=${tab}`}
      replace
    />
  );
};

export default PatientSharedEducationalMaterialsRedirect;
